import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ISelectedMounth } from '../../interface/selectedMounth'
import { ITeachingEntry } from '../../interface/teachingEntry'
import { ILearningEntry } from '../../interface/learningEntry'
import { IAbsenceEntry } from '../../interface/absenceEntry'
import { IIntervals } from '../../interface/intervals'

export interface entrys {
    selectedMounth: ISelectedMounth,
    intervals: Array<IIntervals>,
    dateFrom: string,
    dateTo: string,
    teachingEntrys: Array<ITeachingEntry>,
    loadTeachingEntrys: boolean,
    learningEntrys: Array<ILearningEntry>,
    loadLearningEntrys: boolean,
    absenceEntrys: Array<IAbsenceEntry>,
    loadAbsenceEntrys: boolean,
    intervalCompleted: boolean,
}

const initialState: entrys = {
    selectedMounth: { compledet: "", label: "", value: "" },
    intervals: [],
    dateFrom: "",
    dateTo: "",
    teachingEntrys: [],
    loadTeachingEntrys: false,
    learningEntrys: [],
    loadLearningEntrys: false,
    absenceEntrys: [],
    loadAbsenceEntrys: false,
    intervalCompleted: false
}

export const entrysSlice = createSlice({
    name: 'entrys',
    initialState,
    reducers: {
        setSelectedMounth: (state, action: PayloadAction<ISelectedMounth>) => {
            state.selectedMounth = action.payload
        },

        setIntervals: (state, action: PayloadAction<Array<IIntervals>>) => {
            state.intervals = action.payload
        },

        setDateFrom: (state, action: PayloadAction<string>) => {
            state.dateFrom = action.payload
        },

        setDateTo: (state, action: PayloadAction<string>) => {
            state.dateTo = action.payload
        },

        setTeachingEntrys: (state, action: PayloadAction<Array<ITeachingEntry>>) => {
            state.teachingEntrys = action.payload
        },

        setLoadTeachingEntrys: (state, action: PayloadAction<boolean>) => {
            state.loadTeachingEntrys = action.payload
        },

        setLearningEntrys: (state, action: PayloadAction<Array<ILearningEntry>>) => {
            state.learningEntrys = action.payload
        },

        setLoadLearningEntrys: (state, action: PayloadAction<boolean>) => {
            state.loadLearningEntrys = action.payload
        },

        setAbsenceEntrys: (state, action: PayloadAction<Array<IAbsenceEntry>>) => {
            state.absenceEntrys = action.payload
        },

        setLoadAbsenceEntrys: (state, action: PayloadAction<boolean>) => {
            state.loadAbsenceEntrys = action.payload
        },

        setIntervalCompleted: (state, action: PayloadAction<boolean>) => {
            state.intervalCompleted = action.payload
        },



    },
})

// Action creators are generated for each case reducer function
export const {
    setSelectedMounth,
    setIntervals,
    setDateFrom,
    setDateTo,
    setTeachingEntrys,
    setLoadTeachingEntrys,
    setLearningEntrys,
    setLoadLearningEntrys,
    setAbsenceEntrys,
    setLoadAbsenceEntrys,
    setIntervalCompleted,
} = entrysSlice.actions

export default entrysSlice.reducer